import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,{staticClass:"app-content-root"},[(_vm.isDisconnected === true)?_c('div',{staticClass:"disconnected"}):_vm._e(),_c('Navigation'),_c('router-view'),_c('Snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }